import {
    setData,
    restForm,
    setError,
    setSuccess,
  } from "reducer/attendenceSlice";
  import rootAxios from "requests/rootAxios";
  import { createAsyncThunk } from "@reduxjs/toolkit";

  const Base_url = process.env.REACT_APP_BASE_URL;
  const transformAttendanceData = (attendanceData, batchTrainees) => {
    const transformedData = batchTrainees.map((employeeId) => {
      const employeeAttendance = {
        employeeId, // This will be shown as the first column
        employeeName: `Employee ${employeeId}`, // Optional, can be replaced with actual name if available
      };
  
      // Loop through each date in the attendance array and check if the employee was present or absent
      attendanceData.forEach((attendance) => {
        const isPresent = attendance.present.includes(employeeId);
        const isAbsent = attendance.absent.includes(employeeId);
  
        // Add a column for each date with a checkmark if present, else an empty string
        employeeAttendance[attendance.date] = isPresent ? "✔" : (isAbsent ? "✘" : "");
      });
  
      return employeeAttendance;
    });
  
    return transformedData;
  };
  
  export const updateAttendence = () => async (dispatch, getState) => {
    const attendenceFormDetail = getState().attendenceSlice; 
    const {data:attendanceData,batchId} = attendenceFormDetail;
    let usersPresent = []
    attendanceData.forEach(function(elem){
      if(elem.attendenceMarked){
        usersPresent.push(elem.id??elem.userId)
      }
    })
    if(usersPresent.length<=0){
      dispatch(setError("No user marked as present"));
      throw Error("No user marked as present")
    }
    try {
      const response = await rootAxios.post(`${Base_url}/mark-attendence`, {
        data:{batchId,usersPresent:usersPresent},
      });
      dispatch(setSuccess(true));
      return response.data; // Return response data if needed
    } catch (error) {
      dispatch(setError(error.message));
      throw error; // Rethrow error if needed
    }
  };
  
  export const fetchAttendanceByBatchId = createAsyncThunk(
    "fetchAttendanceByBatchId",
    async (batchId, { rejectWithValue }) => {
      try {
        console.log("Attendecethunk",batchId)
        const response = await rootAxios.post(`${Base_url}/super-user/get-attendance`, {
          batchId ,
        });
        // let transformed = transformAttendanceData(response.data.attendance,response.data.batchTrainees)
        // console.log("transformed",transformed)
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );

  export const markAttendence = createAsyncThunk('markAttendence',
    async  (data,{rejectWithValue})=>{
      try{
        console.log(data);
        const response = await rootAxios.put(`${Base_url}/super-user/create-attendance`,{
          data
        })
        return response.data;
      }catch(error){
        return rejectWithValue(error.response?.data || error.message);
      }
    })